const storedProcedures = {
  sectionMap: 'uspSectionMap',
  timeSeries: 'uspTimeSeries',
  spaceTime: 'uspSpaceTime',
  depthProfile: 'uspDepthProfile',
};

export default Object.freeze(storedProcedures);
